<p-sidebar [(visible)]="showCartSidebar" [position]="'right'" (onHide)="onCloseCart()" [modal]="false"
  class="ss-g-custom-sidebar-width ss-l-pSidebarChat ss-l-sideBarBottom ss-l-productsSidebar z-9 p-0">

  <app-shopping-cart></app-shopping-cart>

  <!-- 🔥 Adiciona o footer com o botão "Comprar Agora" -->
  <ng-template pTemplate="footer">
    <div style="text-align: right;">
      <button pButton pRipple label="Finalizar compra" (click)="onCloseCart()"></button>
    </div>
  </ng-template>

</p-sidebar>
